import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/app/model/store';

const selectState = (state: RootState) => state.registryAssets;

export const selectEntities = (state: RootState) => selectState(state).byId;

export const selectOrderedIds = (state: RootState) =>
  selectState(state).orderedIds;

export const selectItems = createSelector(
  [selectEntities, selectOrderedIds],
  (byId, orderedIds) => orderedIds.map((id) => byId[id]).filter(Boolean),
);

export const selectIsLoading = (state: RootState) =>
  selectState(state).loading === 'pending';

export const selectIsLoadingMore = (state: RootState) => {
  const { loading, loadingMode } = selectState(state);

  return loading === 'pending' && loadingMode === 'append';
};

export const selectHasLoaded = (state: RootState) =>
  selectState(state).loading === 'succeeded';

export const selectError = (state: RootState) => selectState(state).error;

export const selectTotal = (state: RootState) => selectState(state).total;

export const selectAvailableLanguages = (state: RootState) =>
  selectState(state).availableLanguages;

export const selectLoadedCount = (state: RootState) =>
  selectState(state).orderedIds.length;

export const selectHasMore = createSelector(
  [selectLoadedCount, selectTotal],
  (loadedCount, total) => loadedCount < total,
);
